import { BaseEntityLineChart } from '../../../components/Charts';
import { useFacultiesChart } from '../hooks/useFacultiesChart';

interface FacultiesChartProps {
	height?: number;
}

export function FacultiesChart({ height = 400 }: FacultiesChartProps) {
	const { nivoData, isLoading, error } = useFacultiesChart({});

	return (
		<BaseEntityLineChart
			height={height}
			title="Biểu đồ Sinh viên theo Khoa"
			downloadFilename="bieu-do-khoa"
			entityLabel="Chọn khoa"
			entityPlaceholder="Tất cả khoa"
			nivoData={nivoData}
			isLoading={isLoading}
			error={error}
		/>
	);
}
